import styled from 'styled-components'

export const Label = styled.span`
  font-weight: bold;
`

export const Form = styled.form`
  margin: 0;
  width: unset;
  font-size: 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`
